var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryHome = function SvgCategoryHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_home_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_home_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "category_home_svg__Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "category_home_svg__st0",
    d: "M39.3 25.8c-5.2-4.8-10.5-9.6-15.7-14.4l-4.5 3.9v-2.6h-5.6v7.6l-5.2 5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "category_home_svg__st0",
    d: "m12.5 25.3-.3 11.4h22.5V25.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "category_home_svg__st0",
    d: "M24.2 24.7h5.7v5.7h-5.7z"
  }))));
};
export default SvgCategoryHome;